import { render, staticRenderFns } from "./configRelation.vue?vue&type=template&id=5b98fb0e&scoped=true&"
import script from "./configRelation.vue?vue&type=script&lang=js&"
export * from "./configRelation.vue?vue&type=script&lang=js&"
import style0 from "./configRelation.vue?vue&type=style&index=0&id=5b98fb0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b98fb0e",
  null
  
)

export default component.exports